<template>
<!-- 优惠券 -->
<section class="viewContainer">
  <el-tabs type="card" v-model="tabPosition" @tab-click="changeTheme">
    <el-tab-pane label="店铺券" name='1'/>
    <el-tab-pane label="活动券" name='3'/>
    <el-tab-pane label="幸运购券" name='2'/>
    <el-tab-pane label="推广券" name='4'/>
  </el-tabs>
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
    </div>
    <el-collapse-transition>
    <div v-show="show3">
    <el-form style="display:flex;padding: 20px 0 0 20px;">
      <el-form-item style="display:flex;width:25%" label="">
        <el-input v-model="yhqName" placeholder="请输入优惠券名称" maxlength="20"/>
      </el-form-item>
      <el-form-item style="display:flex;width:25%" v-show="tabPosition == '3'">
        <el-input v-model="hdName" placeholder="请输入活动名称" maxlength="20"/>
      </el-form-item>
      <el-form-item style="margin: 0 15px;"> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
    </el-form>
    </div>
    </el-collapse-transition>
  </div>
  <div class="main_container">
    <section class="model_section">
      <p class="model_top_title">优惠券</p>
      <el-button type="danger" @click="addCoupon" v-show="tabPosition != '3'" style="float: right;margin: 5px 10px 0 0;">新 增</el-button>
    </section>
    <div class="table_container">
      <el-table :data="couponList" stripe border>
        <el-table-column label="序号" align="center" width="50">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column label="活动名称" align="center" min-width="150px" v-if="tabPosition == '3'" key="1">
          <template scope="scope">{{scope.row.title}}</template>
        </el-table-column>
        <el-table-column label="券名称" align="center" min-width="150px" key="2">
          <template scope="scope">
            <span class="spanList" :title="scope.row.name">{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="面值(元)" align="center" key="3">
          <template scope="scope">
            <span class="spanList">{{scope.row.faceValue}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="Type" label="类型" align="center">
          <template scope="scope">
            <span class="spanList" v-show="scope.row.Type==1">店铺券</span>
            <span class="spanList" v-show="scope.row.Type==2">幸运购优惠券</span>
            <span class="spanList" v-show="scope.row.Type==3">活动优惠券</span>
          </template>
        </el-table-column> -->
        <el-table-column label="使用门槛" align="center" key="4">
          <template scope="scope">
            <span class="spanList">{{scope.row.useThreshold}}</span>
          </template>
        </el-table-column>
        <el-table-column label="有效期" align="center" width="180px" key="5">
          <template scope="scope">{{scope.row.startTime}}-{{scope.row.endTime}}</template>
        </el-table-column>
        <el-table-column label="售价" align="center" v-if="tabPosition != '2'">
          <template scope="scope"> <span class="spanList">{{scope.row.price}}</span> </template>
        </el-table-column>
        <el-table-column label="发放数量" align="center">
          <template scope="scope"> <span class="spanList">{{scope.row.stock}}</span> </template>
        </el-table-column>
        <el-table-column label="领取数量" align="center">
          <template scope="scope">
            <span class="spanList">{{scope.row.receiveCount}}</span>
          </template>
        </el-table-column>
        <el-table-column label="核销数量" align="center">
          <template scope="scope">
            <span class="spanList" :style="{color: scope.row.useCount == 0 ? '#ccc' : '#6786b4'}"
              @click="activeNum(scope.row)">{{ scope.row.useCount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="转换率" align="center">
          <template scope="scope">
            <span class="spanList">{{scope.row.convertRate}}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template scope="scope">
            <span class="spanList" v-show="scope.row.state == 1">未开启</span>
            <span class="spanList" v-show="scope.row.state == 2">已开启</span>
            <span class="spanList" v-show="scope.row.state == 3">已关闭</span>
            <span class="spanList" v-show="scope.row.state == 4">已过期</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="220px">
          <template scope="scope">
            <!-- 开启 -->
            <span class="operationButton" v-if="tabPosition != '3' && scope.row.state == 1"
              @click="Turnonoff(scope.row, scope.row.state)"> <i class="el-icon-circle-check"></i>开启
            </span>
            <!-- 关闭 -->
            <span class="operationButton" v-if="tabPosition != '3' && scope.row.state == 2"
              @click="Turnonoff(scope.row, scope.row.state)"> <i class="el-icon-circle-close"></i>关闭
            </span>
            <span class="operationButton" v-if="tabPosition != '3' && scope.row.state == 1"
             @click="editDetails(scope.row)"> <i class="el-icon-edit-outline"></i> 编辑
            </span>
            <span class="operationButton" @click="seeInfo(scope.row)">
              <i class="el-icon-view"></i> 查看
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :page-size="10" :current-page="pageIndex" :total="total" style="float:right;margin:10px 0;"/>
    </div>
  </div>

  <!-- 转换订单 右侧抽屉组件 -->
  <el-drawer title="转化订单" custom-class="registrationRecord" :visible.sync="activeOrderDrawer" direction="rtl" size="40%">
    <div class="dataDescription">
      <span>总订单数：<b>{{orderStatistics.OrderCount}}</b>,</span>
      <span> 订单总金额：<b>{{orderStatistics.OrderPrice}} 元</b>,</span>
      <span> 认购总数：<b>{{orderStatistics.GrantCount}}</b>,</span>
      <span> 转换率：<b>{{orderStatistics.ConvertOrderRate}} %</b></span>
    </div>
    <el-table :data="conversionList">
      <el-table-column property="Name" label="用户昵称" align="center"/>
      <el-table-column property="Phone" label="用户电话" align="center"/>
      <el-table-column property="OrderNo" label="订单号" align="center"/>
      <el-table-column property="Price" label="订单金额" align="center"/>
      <el-table-column property="CTime" label="支付时间" align="center"/>
    </el-table>
    <!-- 已转换订单-分页 -->
    <el-pagination layout="prev, pager, next" @current-change="handleConversion" :page-size="10"
      :current-page="conversionPageIndex" :total="conversionTotal" style="float: right; margin-top: 10px"/>
  </el-drawer>

  <!-- 查看详情 -->
  <el-drawer custom-class="registrationRecord" :visible.sync="seeDetails" size="40%">
    <template v-slot:title>
      <div class="drawer_title">{{couponDetails.Name}}</div>
    </template>
    <div class="drawerDiv">
      <div class="zhaungtai">{{couponDetails.StateName}}</div>
      <p>优惠券信息</p>
      <ul>
        <li>售价：<span>{{couponDetails.Price}}</span></li>
        <li>优惠券面值：<span>{{couponDetails.FaceValue}}</span></li>
        <li>使用门槛：<span>{{couponDetails.UseExplain}}</span></li>
        <li>有效时间：<span>{{couponDetails.EffectiveDate}}</span></li>
        <li>每人领取：<span>{{couponDetails.ReceiveNumber}}</span></li>
      </ul>

      <p class="specialInstructions">优惠券特殊说明</p>
      <ul class="richText">
        <li v-html="couponDetails.SpecialInstructions"></li>
      </ul>
      
      <p>领取记录</p>
      <el-table :data="registrationRecordList" border>
        <el-table-column property="username" label="领取用户" align="center"/>
        <el-table-column property="gettime" label="领取时间" align="center"/>
        <el-table-column property="statename" label="状态" align="center"/>
      </el-table>
      <!-- 详情-分页 -->
      <el-pagination layout="prev, pager, next" @current-change="handleSubscription" :page-size="10"
      :current-page="subscriptionPageIndex" :total="subscriptionTotal" style="float: right; margin-top: 10px"/>
    </div>
  </el-drawer>
  
  <!-- 请选择店铺弹框 -->
  <el-dialog :center="true" title="请选择店铺" :visible.sync="dialogVisibleadd" width="25%">
    <el-form class="findform">
      <el-form-item label="店铺名称：" style="display:flex;">
        <el-select v-model="bbid" filterable placeholder="请选择店铺" @change="changeDianpu">
          <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="gonext()">确定</el-button>
    </div>
  </el-dialog>

</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { getCoupons, getActivityCoupons, getHappyDecorationCoupons, postCouponschangestatus, getSeeCoupoon, getGrantCoupoon,
 getCoupoonConvertStatistics, getCoupoonConvertOrder, getEffectiveBrandBusiness, getUserIsAdminOrTZRStaff, getCouponsgetrecord } from "../../api/activityFormList";
export default {
  name: "couponList",
  mixins: [alertTrends],
  data() {
    return {
      show3: true,
      tabPosition: '1', // tab切换标识
      yhqName: '', // 优惠券名称
      hdName: '', // 活动名称
      couponId: "", // 优惠券id
      transformationId: "",
      couponList: [], // 优惠券查询列表
      pageIndex: 1,
      total: 0,

      seeDetails: false, // 查看详情抽屉
      couponDetails: {}, // 优惠券信息
      registrationRecordList: [], // 认购记录列表
      subscriptionPageIndex: 1, // 认购记录分页页码
      subscriptionTotal: 0, // 认购记录总条数

      activeOrderDrawer: false, // 已转换订单右侧弹框
      orderStatistics: {}, // 转换订单统计
      
      conversionList: [], // 已转换订单列表
      conversionPageIndex: 1, // 已转换订单分页页码
      conversionTotal: 0, // 已转换订单总数
      userTZstaff: "", // 是否是超级管理员或甄惠装员工

      dialogVisibleadd: false,
      bbid:'',  // 店铺id
      bbType: '', // 店铺类型
      options1: [],

    };
  },
  methods: {
    // 切换tab
    changeTheme(val) {
      // console.log(val);
      this.yhqName='';
      this.pageIndex = 1;
      this.tabPosition=val.name;
      this.init(this.tabPosition);
    },
    // 查询
    onSubmit() {
      this.pageIndex = 1;
      this.init(this.tabPosition);
    },
    // 查询列表
    init(type) {
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      let obj = {
        // UserId: localStorage.Id,
        bbid: this.bbid, // 店铺id
        key: this.yhqName, // 优惠券名称
        title: this.hdName, // 活动名称
        pageIndex: this.pageIndex,
        pageSize: 10,
        type: type, // 优惠券类型1=普通优惠券、2=快乐装修优惠券、3=活动优惠券 4=店铺推广券
      };
      let thisApi = this.tabPosition=='1'||this.tabPosition=='4'?getCoupons:this.tabPosition=='3'?getActivityCoupons:getHappyDecorationCoupons;
      thisApi(obj).then(data => {
        if(data) {
          if (data.resultCode == 1) {
            this.couponList = data.resultObj.resultObj;
            this.total = data.resultObj.rowsCount
          }else{
            this.couponList = []
            this.total = 0
          }
        } else {
          this.couponList = []
          this.total = 0
        }
      });
    },
    // 列表分页
    handleCurrentChange(val) {
      this.pageIndex = val
      this.init(this.tabPosition);
    },
    // 新增
    addCoupon() {
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      this.$router.push({
        path:"/couponadd",
        query:{
          bbid: this.bbid, // 店铺id
          bbType: this.bbType, // 店铺类型
          type: this.tabPosition // 优惠券类型
        }
      })
      // 判断用户是否是超级管理员或甄惠装员工
      // var obj = {
      //   userId: localStorage.Id // 用户id
      // };
      // getUserIsAdminOrTZRStaff(obj).then((data) => {
      //   if (data.ResultCode == 1) {
      //     this.userTZstaff = data.ResultObj; // true为是超级管理员或甄惠装员工，false为不是
      //     this.$router.push({
      //       path:"/couponadd",
      //       query:{
      //         userTZstaff: this.userTZstaff
      //       }
      //     })
      //     // if(!this.userTZstaff) {
      //     //   this.$router.push({
      //     //     path:"/couponadd",
      //     //   })
      //     // } else {
      //     //   this.showAlert('当前用户不是品牌商员工');
      //     //   return false;
      //     // }
      //   }
      // });
    },
    // 编辑
    editDetails(row) {
      this.$router.push({
        path:"/couponadd",
        query:{
          id: row.id,
          type: this.tabPosition // 优惠券类型
        }
      })
      // 判断用户是否是超级管理员或甄惠装员工
      // var obj = {
      //   userId: localStorage.Id // 用户id
      // };
      // getUserIsAdminOrTZRStaff(obj).then((data) => {
      //   if (data.ResultCode == 1) {
      //     this.userTZstaff = data.ResultObj; // true为是超级管理员或甄惠装员工，false为不是
      //     this.$router.push({
      //       path:"/couponadd",
      //       query:{
      //         id: row.Id,
      //         userTZstaff: this.userTZstaff
      //       }
      //     })
      //     // if(!this.userTZstaff) {
      //     //   this.$router.push({
      //     //     path:"/couponadd",
      //     //     query:{
      //     //       id: row.Id
      //     //     }
      //     //   })
      //     // } else {
      //     //   this.showAlert('当前用户不是品牌商员工');
      //     //   return false;
      //     // }
      //   }
      // });
    },
    // 查看
    seeInfo(row) {
      this.couponId = row.id;
      this.seeDetails = true;
      this.subscriptionPageIndex = 1;
      // 查询详情信息
      var obj = { couponId: this.couponId, };
      getSeeCoupoon(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.couponDetails = data.ResultObj;
        }
      });
      this.pushSubscriptionRecords(); // 认购记录列表
    },
    // 认购记录接口
    pushSubscriptionRecords() {
      let obj = {
        pageIndex: this.subscriptionPageIndex, // 页码
        pageSize: 10, // 条数
      };
      getCouponsgetrecord(obj,this.couponId).then(data => {
        if (data.resultCode == 1) {
          this.registrationRecordList = data.resultObj.list;
          this.subscriptionTotal = data.resultObj.totalcount;
        } else {
          this.registrationRecordList = [];
          this.subscriptionTotal=0;
        }
      });
    },
    // 查询认购记录分页
    handleSubscription(val) {
      this.subscriptionPageIndex = val;
      this.pushSubscriptionRecords();
    },
    // 开启&关闭
    Turnonoff(row,type) {
      this.$swal({
        type: "warning",
        text: type==1?"您确定开启吗？":"您确定关闭吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then(res => {
        if (res.value) {
          let obj = {
            couponid: row.id, // 优惠券ID
            shopid: this.bbid, // 店铺ID
            status: type==1?2:3, // 操作状态 2=开启、3=关闭
          };
          postCouponschangestatus(obj).then(data => {
            if (data.resultCode == 1) {
              this.showAlert('操作成功', 'success');
              this.init(this.tabPosition);
            }
          });
        }
      });
    },
    // 点击已转换订单
    activeNum(row) {
      if (row.UseCount == 0) { return; }
      this.transformationId = row.id; // 获取优惠券id
      this.activeOrderDrawer = true;
      // 调用 获取已转换订单统计
      var obj = {
        couponId: this.transformationId, // 优惠券id
      };
      getCoupoonConvertStatistics(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.orderStatistics = data.ResultObj;
        } else {
          this.orderStatistics = [];
        }
      });
      this.getActiveNum(); // 调用已转换订单列表
    },
    // 查询已转换订单列表
    getActiveNum() {
      var obj = {
        CouponId: this.transformationId, // 优惠券id
        PageIndex: this.conversionPageIndex, // 页码
        PageSize: 10, // 条数
      };
      getCoupoonConvertOrder(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.conversionList = data.ResultObj;
          this.conversionTotal = data.RowsCount;
        } else {
          this.conversionList = [];
        }
      });
    },
    // 查询已转换订单分页
    handleConversion(val) {
      this.conversionPageIndex = val;
      this.getActiveNum();
    },
    // 初始化弹框
    tankuang(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      getEffectiveBrandBusiness(addParams).then(data => {
        if (data.resultCode == 1) {
          if(data.resultObj.length>1) {
            this.dialogVisibleadd = true;
            this.options1 = data.resultObj;
          } else {
            this.dialogVisibleadd = false;
            this.bbid = data.resultObj[0].id; // 店铺id
            this.bbType = data.resultObj[0].bbType; // 店铺类型
            this.gonext();
          }
        }else{
          this.showAlert('请先在店铺信息功能中创建自己店铺');
          return false;
        }
      })
    },
    changeDianpu(id) {
      let the = this.options1.find(item => item.id===id);
      // console.log(the,'获取店铺信息')
      this.bbid = the.id; // 店铺id
      this.bbType = the.bbType; // 店铺类型
    },
    gonext(){
      if(this.bbid == ""){
        this.showAlert('请选择店铺名称');
        return false
      }
      this.init(1); // 查询列表
      this.dialogVisibleadd = false;
    },
  },
  // html加载完成后执行 页面初始化
  mounted() {
    // let bbid = this.$route.query.bbid;
    this.bbid = this.$route.params.bbid?this.$route.params.bbid:'';
    this.bbType = this.$route.params.bbType?this.$route.params.bbType:'';
    this.tabPosition = this.$route.params.type?this.$route.params.type:'1';
    // this.bbid = localStorage.bbid;
    if(this.bbid === '') {
      this.tankuang();
    } else {
      this.init(this.tabPosition); // 查询列表
    }
  }
  // 缓存数据
  // beforeRouteEnter(to, from, next) {
  //   if(from.path === '/couponadd'){
  //     to.meta.init = false;
  //   } else {
  //     to.meta.init = true
  //   }
  //   next()
  // },
  // activated() {
  //   if(this.$route.meta.init){
  //     this.init();
  //     this.total = 1
  //     this.pageIndex = 1
  //   }
  // }
};
</script>
<style scoped>
/* 操作按钮 */
.operationButton {
  color:#6786b4;
  margin-left:8px;
  cursor: pointer;
}
/* 抽屉-详情 */
.drawerDiv {
  width: 100%;
  position: relative;
  margin-top: -15px;
}
.drawerDiv>p {
  width: 80%;
  font-size: 15px;
  font-weight: bold;
}
.drawerDiv>ul {
  width: 93%;
  border-bottom: 1px solid #eee;
  padding-left: 30px;
  padding-bottom: 10px;
}
.drawerDiv>ul>li {
  width: 100%;
  color: #888;
  font-size: 15px;
  margin-bottom: 5px;
}
.drawerDiv>ul>li>span {
  font-size: 16px;
  color: #333;
  margin-left: 5px;
  line-height: 26px;
}
.zhaungtai {
  width: 60px;
  height: 60px;
  line-height: 55px;
  color: #fff;
  background: #ccc;
  position: absolute;
  right: 0;
  border-radius: 50px;
  text-align: center;
}
/* 优惠券特殊说明 */
.specialInstructions {
  height: 6px;
}
/* 富文本 */
.richText {
  width: 100%;
  overflow-x: scroll;
}
.richText>li {
  color: #333 !important;
}
</style>


// WEBPACK FOOTER //
// couponList.vue?1b3956d8